module.exports = __webpack_public_path__ + "img/rueckseite_neu_sem.d87a9efc.svg";